




















































import { Component, Mixins } from "vue-property-decorator";

import AppContent from "@/components/AppContent/AppContent.vue";
import AppHeader from "@/components/AppHeader/AppHeader.vue";
import AppHeaderBackWithTitle from "@/components/AppHeader/AppHeaderBackWithTitle.vue";

import ClassStepperForm from "@/components/ClassStepperForm/ClassStepperForm.vue";

import BasePopup from "@/components/BasePopup/BasePopup.vue";
import BaseButton from "@/components/BaseButton/BaseButton.vue";
import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";
import BaseAlert from "@/components/BaseAlert/BaseAlert.vue";

import { Action, State } from "vuex-class";
import { AxiosPromise, AxiosResponse } from "axios";

import RequestState from "@/utils/mixins/RequestState";
import { IClass, IClassPayload } from "@/models/interfaces/classes";
import { ITeacher } from "@/models/interfaces/teachers";
import { IStudent } from "@/models/interfaces/students";
import { IVuexState } from "@/models/interfaces/store";

@Component({
  components: {
    AppContent,
    AppHeader,
    AppHeaderBackWithTitle,

    BasePopup,
    BaseButton,
    BaseSpinner,
    BaseAlert,

    ClassStepperForm
  }
})
export default class EditClassView extends Mixins(RequestState) {
  @State("students", { namespace: "classes" })
  private classStudents!: IVuexState<IStudent[]>;

  @State("classTeachers", { namespace: "classes" })
  private classTeachers!: IVuexState<ITeacher[]>;

  @Action("classes/editClass")
  private editClass!: (payload: {
    data: IClassPayload;
    classId: string;
  }) => AxiosPromise;

  @Action("classes/assignStudentsToClass")
  private assignStudentsToClass!: (data: {
    userIds: string[];
    classId: string;
  }) => AxiosPromise;

  @Action("classes/assignTeachersToClass")
  private assignTeachersToClass!: (data: {
    userIds: string[];
    classId: string;
  }) => AxiosPromise;

  @Action("classes/fetchTeachersForClass")
  private fetchTeachersForClass!: (classId: string) => Promise<ITeacher[]>;

  @Action("classes/fetchStudentsInClass")
  private fetchStudentsInClass!: (classId: string) => Promise<IStudent[]>;

  private successMsg = "Group has been updated!";
  private popupMessage = "";
  private currentStepIndex = 0;

  private isSubmitting = false;
  private showPopup = false;
  private popupTimeout = 0;

  public $refs!: {
    form: HTMLDivElement & {
      onPrev: () => void;
    };
  };

  private get initialData() {
    return {
      className: this.$route.query.name.toString(),
      teachers: this.classTeachers.data?.map(item => item.userId),
      students: this.classStudents.data?.map(item => item.userId)
    };
  }

  private onPrev() {
    this.$refs.form.onPrev();
  }

  private async submit(payload: {
    class: {
      schoolId: string;
      data: IClassPayload;
    };
    students: string[];
    teachers: string[];
  }) {
    this.isSubmitting = true;
    const { classId } = this.$route.params;

    try {
      await Promise.all([
        this.editClass({
          data: {
            className: payload.class.data.className
          },
          classId
        }),
        this.assignStudentsToClass({
          userIds: payload.students,
          classId
        }),
        this.assignTeachersToClass({
          userIds: payload.teachers,
          classId
        })
      ]);

      this.isSubmitting = false;
      this.showPopup = true;
      this.popupMessage = this.successMsg;
    } catch (error) {
      this.isSubmitting = false;
      const { response } = error;

      if (!response || response.status !== 403) {
        this.isSubmitting = false;
        this.showPopup = true;
        this.popupMessage = this.$t("views.classes.errors.update") as string;
      }
    }
  }

  private setIndex(index: number) {
    this.currentStepIndex = index;
  }

  private onPopupClose() {
    this.showPopup = false;

    if (this.popupMessage === this.successMsg) {
      this.popupTimeout = window.setTimeout(() => {
        this.$router.push("/classes");
      }, 500);
    }
  }

  private mounted() {
    const { classId } = this.$route.params;

    this.fetchStudentsInClass(classId);
    this.fetchTeachersForClass(classId);
  }

  public beforeDestroy() {
    window.clearTimeout(this.popupTimeout);
  }
}
